// import React, { useCallback, useEffect, useState } from "react";
// import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import * as XLSX from 'xlsx';
// import {
//   Row, Col, Card, Table, Button, Input, AutoComplete,
//   notification, Modal, Select, Avatar, Typography, TableColumnsType,
//   Checkbox, DatePicker, Drawer, Form, InputNumber, Space, Tooltip, Upload
// } from "antd";


// import axios from "axios";
// import { baseUrl } from "../../config";
// import {
//   DeleteOutlined, FileExcelOutlined, CalendarOutlined, SendOutlined,
//   FilterOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined,
//   EyeOutlined, UserOutlined, PlusOutlined, UploadOutlined
// } from "@ant-design/icons";
// import userDummy from "../../assets/images/dummy-user.png";
// import { getPermissions, hasPermission } from '../../components/permissions';
// import '../../assets/styles/custom_style.css';
// import moment from 'moment';

// import AddUserDetailsModel from './Form';
// import AddMessage from "./components/purnimaForm";
// import AddImageForm from "./components/purnimaFormWithImg";
// import ImportListModal from './components/importListModal';

// const { confirm } = Modal;
// const { Search } = Input;
// const { Option } = Select;
// const { Title } = Typography;
// const { Item } = Form;
// const { TextArea } = Input;


// // Table columns definition
// const columns = [

//   {
//     title: "#",
//     dataIndex: "key",
//     key: "key",
//     fixed: 'left',
//     width: 50,
//   },
//   {
//     title: "Phone no",
//     dataIndex: "phone_no",
//     key: "phone_no",
//     fixed: 'left',
//     width: 150,
//   },
//   {
//     title: "Name",
//     dataIndex: "name",
//     key: "name",
//   },
//   {
//     title: "Amount Pledge",
//     dataIndex: "amount_pledge",
//     key: "amount_pledge",
//   },
//   {
//     title: 'Father Name',
//     dataIndex: 'father_name',
//     key: 'father_name',
//   },

//   {
//     title: "Village",
//     dataIndex: "village",
//     key: "village"
//   },
//   {
//     title: "Tehsil",
//     dataIndex: "tehsil",
//     key: "tehsil",
//   },
//   {
//     title: "District",
//     dataIndex: "district",
//     key: "district",
//   },

//   {
//     title: "Occupation",
//     dataIndex: "occupation",
//     key: "occupation",
//   },
//   {
//     title: "Occ District",
//     dataIndex: "occ_district",
//     key: "occ_district",
//   },
//   {
//     title: "Inspiration Remark",
//     dataIndex: "inspiration_remark",
//     key: "inspiration_remark",
//   },

//   {
//     title: "Alternative No",
//     dataIndex: "alternative_no",
//     key: "alternative_no",
//   },
//   {
//     title: "DoB",
//     dataIndex: "dob",
//     key: "dob",
//   },
//   {
//     title: "From Which Year",
//     dataIndex: "from_which_year",
//     key: "from_which_year",
//   },
//   {
//     title: "Visited Time’s",
//     dataIndex: "visited_time",
//     key: "visited_time",
//   },
//   {
//     title: "Vehicle",
//     dataIndex: "vehicle_by",
//     key: "vehicle_by",
//   },
//   {
//     title: "Time of visit",
//     dataIndex: "time_visit",
//     key: "time_visit",
//   },
//   {
//     title: "Remark",
//     dataIndex: "remark",
//     key: "remark",
//   },
//   {
//     title: "Date",
//     dataIndex: "createdAt",
//     key: "createdAt",
//   },
//   {
//     title: "Action",
//     key: "action",
//     dataIndex: "action",
//     fixed: 'right',
//   }
// ];

// function PurnimaList() {

//   const history = useHistory();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const currentPageQuery = parseInt(queryParams.get('page')) || 1;
//   const limitQuery = parseInt(queryParams.get('limit')) || 20;

//   const [userList, setUserList] = useState([]);
//   const [pagination, setPagination] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(limitQuery);
//   const [sortField, setSortField] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [search, setSearch] = useState('');
//   const [staffList, setStaffList] = useState([]);
//   const [purnimaSettingRecord, setPurnimaSettingRecord] = useState();
//   const [filters, setFilters] = useState({
//     name: queryParams.get('name') || '',
//     email: queryParams.get('email') || '',
//     phone: queryParams.get('phone') || '',
//     father_name: queryParams.get('father_name') || '',
//     village: queryParams.get('village') || '',
//     district: queryParams.get('district') || '',
//     occ_address: queryParams.get('occ_address') || '',
//     amount: queryParams.get('amount') || '',
//     dob: queryParams.get('dob') || '',
//     createdAt: queryParams.get('createdAt') || '',
//   });

//   const [showUserFilter, setShowUserFilter] = useState(true);
//   const [showPurnimaMessageForm, setShowPurnimaMessageForm] = useState(false);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);
//   const [currentImage, setCurrentImage] = useState("");
//   const { id } = useParams(); // Extract id from URL 
//   const [form] = Form.useForm();
//   const [isUpdateMode, setIsUpdateMode] = useState(false);
//   const [txnDate, setTxnDate] = useState();
//   const [addForm, setAddForm] = useState(false);
//   const [sendMessage, setSendMessage] = useState(false);
//   const [AddUserDetailsFormModel, setAddUserDetailsModel] = useState(false);
//   const [userId, setuserId] = useState();

//   useEffect(() => {
//     const { state } = history.location; // Get the state from history
//     const restoredPage = state?.page || currentPage; // Restore page from state or use current page
//     const restoredLimit = state?.limit || limit; // Restore limit from state or use current limit

//     // Call getUserList with restored page and limit
//     getUserList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
//   }, [history.location]);


//   const AddUserDetailsClose = () => {
//     setAddUserDetailsModel(false)
//     const { state } = history.location; // Get the state from history
//     const restoredPage = state?.page || currentPage; // Restore page from state or use current page
//     const restoredLimit = state?.limit || limit; // Restore limit from state or use current limit

//     // Call getUserList with restored page and limit
//     getUserList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
//   }



//   async function getUserList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
//     try {
//       setCurrentPage(page);
//       setLimit(limit);
//       const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
//       const searchParam = search ? `&search=${search}` : '';
//       const filterParams = Object.keys(filters)
//         .map(key => `${key}=${filters[key]}`)
//         .join('&');
//       const response = await axios.get(`${baseUrl}/purnima_form/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         }
//       });
//       if (response.data.status) {
//         setUserList(response.data.result);
//         // setUserList([])
//         setPagination({
//           current: page,
//           pageSize: limit,
//           total: response.data.totalCount
//         });
//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRight'
//         });
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   async function handleDelete(id) {
//     try {
//       const response = await axios.delete(`${baseUrl}/purnima_form/delete/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         },
//       });
//       if (response.status === 200) {
//         getUserList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
//         notification.success({
//           message: 'Success',
//           description: 'Record deleted successfully!',
//           placement: 'topRight'
//         });
//       } else {
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRight'
//         });
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };

//   const showDeleteConfirm = (id) => {
//     confirm({
//       title: 'Are you sure you want to delete this item?',
//       icon: <ExclamationCircleOutlined />,
//       content: 'This action cannot be undone.',
//       okText: 'Yes',
//       okType: 'danger',
//       cancelText: 'No',
//       onOk() {
//         handleDelete(id);
//       },
//     });
//   };

//   const handleTableChange = (pagination, filters, sorter) => {
//     const { current, pageSize } = pagination;
//     const { field, order } = sorter;
//     const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
//     setSortField(field);
//     setSortOrder(formattedOrder);
//     setFilters(filters);

//     // Update both current page and limit in the history
//     history.push(`?page=${current}&limit=${pageSize}`);

//     // Fetch the updated payment list
//     getUserList(current, pageSize, field, formattedOrder, search, filters);
//   };



//   const handleLimitChange = value => {
//     setLimit(value);

//     // Update URL with the new limit and reset page to 1
//     const updatedQueryParams = new URLSearchParams(location.search);
//     updatedQueryParams.set('limit', value);
//     updatedQueryParams.set('page', 1); // Reset to first page whenever limit changes

//     // Push new URL with updated query params
//     history.push(`?${updatedQueryParams.toString()}`);

//     // Call the API to fetch data with updated limit
//     getUserList(1, value);  // Assuming your API call accepts page and limit
//   };




//   const handleFilterChange = (field, value) => {
//     const newFilters = {
//       ...filters,
//       [field]: value
//     };
//     setFilters(newFilters);

//     // Optionally, update the URL without triggering a search immediately
//     const updatedQueryParams = new URLSearchParams(location.search);
//     Object.keys(newFilters).forEach(key => {
//       if (newFilters[key]) {
//         updatedQueryParams.set(key, newFilters[key]);
//       } else {
//         updatedQueryParams.delete(key); // Remove empty filters from the URL
//       }
//     });
//     history.push(`?${updatedQueryParams.toString()}`);
//   };


//   const handleUserFilterCheckboxChange = (e) => {
//     setShowUserFilter(e.target.checked);

//   };

//   const handlePurnimaFormCheckboxChange = async (e) => {
//     await getLatestPurnimaSettingRecord();
//     setShowPurnimaMessageForm(e.target.checked);
//   };

//   // Purnima setting message
//   async function getLatestPurnimaSettingRecord() {
//     try {
//       const response = await axios.get(`${baseUrl}/purnima-message-setting/read`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         }
//       });
//       if (response.data.status) {
//         setPurnimaSettingRecord(response.data.result);

//       } else {
//         setPurnimaSettingRecord()
//         notification.info({
//           message: 'Info',
//           description: response.data.message,
//           placement: 'topRight'
//         });
//       }
//     } catch (error) {
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };



//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   const handleCancelImportList = () => {
//     setIsModalVisibleImportList(false);
//   };

//   const handleOnSuccess = () => {
//     setIsModalVisibleImportList(false);
//     getUserList();
//   };

//   const onFinish = async (values) => {
//     try {
//       if (txnDate) {
//         const formattedDate = moment(txnDate).format('YYYY-MM-DD');
//         values.dob = formattedDate;
//       } else {
//         values.dob = '';
//       }
//       values.action = sendMessage ? 'save_send' : 'save';
//       if (isUpdateMode) {
//         const response = await axios.patch(`${baseUrl}/purnima_form/update/${id}`, values, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
//           },
//         });
//         if (response.status === 200) {
//           notification.success({
//             message: 'Success',
//             description: 'Record updated successfully!',
//             placement: 'topRight'
//           });
//           history.push('/purnima-form');
//         } else {
//           notification.info({
//             message: 'Info',
//             description: response.data.message,
//             placement: 'topRight'
//           });
//         }
//       } else {
//         const response = await axios.post(`${baseUrl}/purnima_form/create`, values, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
//           },
//         });
//         if (response.status === 200) {
//           notification.success({
//             message: 'Success',
//             description: 'Purnima Member added successfully!',
//             placement: 'topRight'
//           });
//           form.resetFields();
//           setTxnDate('');

//           getUserList();

          
//         } else {
//           notification.info({
//             message: 'Info',
//             description: response.data.message,
//             placement: 'topRight'
//           });
//         }
//       }
//     } catch (error) {
//       console.error("API error:", error);
//       notification.info({
//         message: 'Info',
//         description: error.response?.data?.message,
//         placement: 'topRight'
//       });
//     }
//   };



//   const handleDateChange = (date, dateString) => {
//     if (date) {
//       const formattedDate = moment(date).format('YYYY-MM-DD');
//       setTxnDate(formattedDate)
//     } else {
//       setTxnDate(null);
//     }
//   };

//   const toggleFormVisibility = () => {
//     setAddForm(prevState => !prevState);  
//   };


//   const handleResendMessage = async (userId) => {
//     Modal.confirm({
//       title: 'Are you sure you want to Re-send message?',
//       onOk: async () => {
//         try {
//           const response = await axios.patch(`${baseUrl}/purnima_form/messageresend/${userId}`, { send: 'yes' }, {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
//             },
//           });

//           if (response.status === 200) {

//             const { state } = history.location; // Get the state from history
//             const restoredPage = state?.page || currentPage; // Restore page from state or use current page
//             const restoredLimit = state?.limit || limit; // Restore limit from state or use current limit

//             // Call getUserList with restored page and limit
//             getUserList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);

//             notification.success({
//               message: 'Success',
//               description: 'Message sent successfully',
//               placement: 'topRight',

//             });
//           }
//         } catch (error) {
//           notification.info({
//             message: 'Info',
//             description: "Failed to verify payment",
//             placement: 'topRight'
//           });

//         }
//       },
//     });
//   }

//   const exportToExcel = async () => {
//     const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
//     const searchParam = search ? `&search=${search}` : '';
//     const filterParams = Object.keys(filters)
//       .map(key => `${key}=${filters[key]}`)
//       .join('&');
//     const response = await axios.get(`${baseUrl}/purnima_form/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//       }
//     });
//     if (response.data.status) {
//       const formattedData = response.data.result.map((user, index) => ({
//         "Sr.No": index + 1,
//         "Phone no": user.phone_no,
//         "Name": user.name,
//         "Amount Pledge": user.amount,
//         "Father Name": user.father_name,
//         "Dob": user.createdAt ? moment(user.dob).format('DD-MM-YYYY') : '-',
//         "Village": user.village,
//         "Tehsil": user.tehsil,
//         "District": user.district,
//         "Occupation": user.occupation,
//         "Occupation District": user.occ_district,
//         "Inspiration Remark": user.inspiration_remark,
//         "Alternative No": user.alternative_no,
//         "From Which Year": user.from_which_year,
//         "Visited Time’s ( Counting Feature )": user.visited_time,
//         "Vehicle ( by Train, Bus, Own )": user.vehicle_by,
//         "Time of visit": user.time_visit,
//         "Date": user.createdAt ? moment(user.createdAt).format('DD-MM-YYYY') : '-',
//         "Remark": user.remark
//       }));

//       const worksheet = XLSX.utils.json_to_sheet(formattedData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Purnima-members-list");
//       XLSX.writeFile(workbook, "Purnima-List.xlsx");
//     } else {
//       notification.info({
//         message: 'Info',
//         description: response.data.message,
//         placement: 'topRight'
//       });
//     }
//   };


//   const AddUserDetails = async (userId) => {
//     console.log('uid', userId)
//     setuserId(userId);
//     setAddUserDetailsModel(true)

//   }

//   return (
//     <div className="tabled">
//       <Row gutter={[24, 0]}>



//         {addForm && (
//           <Col xs="24" xl={24}>
//             <div className="tabled">
//               <Row gutter={[24, 0]}>
//                 <Col xs="24" xl={24}>
//                   <Card
//                     bordered={false}
//                     className="criclebox tablespace mb-24"
//                     title={isUpdateMode ? "Update Purnima Form" : "Add Purnima Form"}
//                   >
//                     <Form style={{ "padding": "20px" }} form={form} onFinish={onFinish} layout="vertical">
//                       <Row gutter={[16, 16]}>


//                         <Col xs={24} sm={4} lg={4}>
//                           <Item
//                             label="Phone No"
//                             name="phone_no"
//                             rules={[{ required: true, message: 'Please Enter  Phone no' },
//                             {
//                               pattern: /^\d{10,12}$/,
//                               message: 'Phone no must be between 10 and 12 digits!',
//                             }
//                             ]}
//                           >

//                             <Input type="number" placeholder="Enter Phone no" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={4} lg={4}>
//                           <Item
//                             label="Name"
//                             name="name"
//                             rules={[{ required: true, message: 'Please Enter Name' }]}
//                           >
//                             <Input placeholder="Enter Name" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={6} lg={4}>
//                           <Item
//                             label="Father Name"
//                             name="father_name"
//                           >
//                             <Input placeholder="Enter Father Name" />
//                           </Item>
//                         </Col>

//                         <Col xs={24} sm={6} lg={4}>
//                           <Item
//                             label="Village"
//                             name="village"
//                           >
//                             <Input placeholder="Enter Village" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={6} lg={4}>
//                           <Item
//                             label="Tehsil"
//                             name="tehsil"
//                           >
//                             <Input placeholder="Enter Tehsil" />
//                           </Item>
//                         </Col>

//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="District"
//                             name="district"
//                           >
//                             <Input placeholder="Enter District" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Occupation"
//                             name="occupation"
//                           >
//                             <Input placeholder="Enter Occupation" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Occupation District"
//                             name="occ_district"
//                           >
//                             <Input placeholder="Enter Occupation District" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Inspiration Remark"
//                             name="inspiration_remark"
//                           >
//                             <Input placeholder="Enter Inspiration Remark" />
//                           </Item>
//                         </Col>

//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Amount Pledge"
//                             name="amount_pledge"
//                           >
//                             <Input type="number" placeholder="Enter Amount Pledge" />
//                           </Item>
//                         </Col>

//                         <Col xs={24} sm={4} lg={4}>
//                           <Item label="DOB" >
//                             <DatePicker onChange={handleDateChange} value={txnDate && moment(txnDate)} className="filter_dob" format="DD-MM-YYYY" placeholder="Select DOB" prefix={<CalendarOutlined />} />

//                           </Item>
//                         </Col>

//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Alternative No"
//                             name="alternative_no"
//                           >
//                             <Input type="number" placeholder="Enter Alternative No" />
//                           </Item>
//                         </Col>

//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="From Which Year"
//                             name="from_which_year"
//                           >
//                             <Input placeholder="Enter From Which Year" />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Visited Time’s "
//                             name="visited_time"
//                           >
//                             <Input placeholder="Enter Visited Time’s " />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Vehicle "
//                             name="vehicle_by"
//                           >
//                             <Input placeholder="Enter Vehicle " />
//                           </Item>
//                         </Col>
//                         <Col xs={24} sm={12} lg={4}>
//                           <Item
//                             label="Time of visit"
//                             name="time_visit"
//                           >
//                             <Input placeholder="Enter Time of visit " />
//                           </Item>
//                         </Col>



//                         <Col xs={24} sm={12} lg={8}>
//                           <Item
//                             label="Remark"
//                             name="remark"
//                           >
//                             <TextArea placeholder="Enter Remark" rows={2} />
//                           </Item>
//                         </Col>

//                       </Row>
//                       <Row style={{ textAlign: 'right' }}>
//                         <Col xs={24} sm={24} lg={24}>
//                           <Item>
//                             <Button
//                               type="primary"
//                               htmlType="submit"
//                               onClick={() => setSendMessage(false)}
//                               style={{ marginRight: '10px' }} // Add space between buttons
//                             >
//                               {isUpdateMode ? "Update" : "Save"}
//                             </Button>

                           
//                           </Item>
//                         </Col>
//                       </Row>

//                     </Form>
//                   </Card>
//                 </Col>
//               </Row>
//             </div>
//           </Col>

//         )}
//         <Col xs="24" xl={24}>
//           <Card
//             bordered={false}
//             className="criclebox tablespace mb-24"
//             title="Purnima Form List"
//             extra={
//               <div style={{ display: 'flex', gap: '10px' }}>
//                 <Button
//                   type="default"
//                   icon={<FileExcelOutlined />}
//                   onClick={() => setIsModalVisibleImportList(true)}
//                   style={{
//                     padding: '4px 15px',
//                     fontSize: '14px',
//                     lineHeight: '22px',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   Import List
//                 </Button>
//                 {hasPermission('/purnima-form', 'createPermission') && (

//                   <button onClick={toggleFormVisibility} className="custom-btn">Add Purnima Form</button>


//                 )}
//                 {hasPermission('/purnima-form', 'downloadPermission') && (
//                 <Button
//                   type="default"
//                   icon={<FileExcelOutlined />}
//                   onClick={exportToExcel}
//                   style={{
//                     padding: '4px 15px',
//                     fontSize: '14px',
//                     lineHeight: '22px',
//                     borderRadius: '5px',
//                   }}
//                 >
//                   Excel Download
//                 </Button>
//                 )}
//               </div>
//             }

//           >
//             <div className="table-responsive">
//               <Table
//                 columns={columns}
//                 pagination={false}
//                 scroll={{ x: 'max-content' }}
//                 bordered
//                 title={() => (
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Row gutter={[16, 16]}>
//                       <Col xs={24}>
//                         <PlusOutlined /> <Checkbox onChange={handlePurnimaFormCheckboxChange}><Title style={{ fontSize: 13 }} level={5}>Purnima Message</Title></Checkbox>
//                       </Col>
//                       {showPurnimaMessageForm && (
//                         <>
//                           <Col xs={24}>
//                             <AddMessage record={purnimaSettingRecord && purnimaSettingRecord?.purnimaMsgRecords.length > 0 && purnimaSettingRecord?.purnimaMsgRecords[0]} />
//                           </Col>
//                           <Col xs={24}>
//                             <AddImageForm record={purnimaSettingRecord && purnimaSettingRecord?.purnimaImgRecords.length > 0 && purnimaSettingRecord?.purnimaImgRecords[0]} />
//                           </Col>
//                         </>
//                       )}
//                       <Col xs={24}>
//                         <FilterOutlined /> <Checkbox onChange={handleUserFilterCheckboxChange}><Title style={{ fontSize: 13 }} level={5}>Form Filter</Title></Checkbox>
//                       </Col>
//                       {showUserFilter && (
//                         <>
//                           <Col span={4}> <Input placeholder="Phone no" value={filters.phone_no} onChange={e => handleFilterChange('phone_no', e.target.value)} /></Col>
//                           <Col span={4}><Input placeholder="Name" value={filters.name} onChange={e => handleFilterChange('name', e.target.value)} /></Col>
//                           <Col span={4}> <Input placeholder="Father Name" value={filters.father_name} onChange={e => handleFilterChange('father_name', e.target.value)} /></Col>
//                           <Col span={4}><Input placeholder="Village" value={filters.village} onChange={e => handleFilterChange('village', e.target.value)} /></Col>

//                           <Col span={4}><Input placeholder="Tehsil" value={filters.tehsil} onChange={e => handleFilterChange('tehsil', e.target.value)} /></Col>
//                           <Col span={4}>
//                             <Input placeholder="District" value={filters.district} onChange={e => handleFilterChange('district', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Occupation" value={filters.occupation} onChange={e => handleFilterChange('occupation', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Occ District" value={filters.occ_district} onChange={e => handleFilterChange('occ_district', e.target.value)}
//                             />
//                           </Col>

//                           <Col span={4}>
//                             <Input placeholder="Amount Pledge" value={filters.amount_pledge} onChange={e => handleFilterChange('amount_pledge', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Alternative No" value={filters.alternative_no} onChange={e => handleFilterChange('alternative_no', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <DatePicker className="filter_dob CustomInputSet"
//                               format="DD-MM-YYYY" value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null}
//                               onChange={(date, dateString) => handleFilterChange('dob', dateString)} placeholder="Dob Date"
//                             />
//                           </Col>

//                           <Col span={4}>
//                             <Input placeholder="From Which Year" value={filters.from_which_year} onChange={e => handleFilterChange('from_which_year', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Visited Time’s" value={filters.visited_time} onChange={e => handleFilterChange('visited_time', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Vehicle By" value={filters.vehicle_by} onChange={e => handleFilterChange('vehicle_by', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Time of visit" value={filters.time_visit} onChange={e => handleFilterChange('time_visit', e.target.value)}
//                             />
//                           </Col>
//                           <Col span={4}>
//                             <Input placeholder="Remark" value={filters.remark} onChange={e => handleFilterChange('remark', e.target.value)}
//                             />
//                           </Col>



//                           <Col span={4}>
//                             <DatePicker className="filter_dob CustomInputSet"
//                               format="DD-MM-YYYY" value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
//                               onChange={(date, dateString) => handleFilterChange('createdAt', dateString)} placeholder="Entry Date"
//                             />
//                           </Col>


//                         </>
//                       )}

//                       <Col xs={24}>
//                         <span style={{ marginRight: 10 }}>Records per page:</span>
//                         <Select defaultValue={20} onChange={handleLimitChange}>
//                           <Option value={20}>20</Option>
//                           <Option value={40}>40</Option>
//                           <Option value={60}>60</Option>
//                           <Option value={80}>80</Option>
//                           <Option value={100}>100</Option>
//                         </Select>
//                       </Col>
//                     </Row>
//                   </div>
//                 )}
//                 dataSource={userList.map((user, index) => {
//                   const isMatch = user.phone_no === user.user_phone_no;
//                   return {
//                     key: (limit * (currentPage - 1)) + index + 1,
//                     phone_no: (
//                       <div className="author-info">
//                         <Tooltip title="Number match with origin member!">
//                           <Title
//                             level={5}
//                             style={{
//                               textAlign: 'center',
//                               color: isMatch ? 'white' : 'inherit',
//                               backgroundColor: isMatch ? 'green' : 'inherit',
//                               padding: isMatch ? '5px' : 'inherit',
//                               borderRadius: isMatch ? '5px' : 'inherit'
//                             }}
//                           >
//                             {user.phone_no}
//                           </Title>
//                         </Tooltip>
//                       </div>
//                     ),
//                     name: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}> {user.name}</Title>
//                         </div>
//                       </>
//                     ),
//                     father_name: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.father_name}  </Title>
//                         </div>
//                       </>
//                     ),
//                     amount_pledge: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>Rs.{user.amount_pledge}  </Title>
//                         </div>
//                       </>
//                     ),

//                     dob: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.dob ? moment(user.dob).format('DD MMMM YYYY') : '-'}</Title>
//                         </div>
//                       </>
//                     ),
//                     village: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.village}  </Title>
//                         </div>
//                       </>
//                     ),
//                     tehsil: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.tehsil}  </Title>
//                         </div>
//                       </>
//                     ),
//                     district: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.district}  </Title>
//                         </div>
//                       </>
//                     ),
//                     occupation: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.occupation}  </Title>
//                         </div>
//                       </>
//                     ),
//                     occ_district: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.occ_district}  </Title>
//                         </div>
//                       </>
//                     ),
//                     inspiration_remark: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.inspiration_remark}  </Title>
//                         </div>
//                       </>
//                     ),
//                     alternative_no: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.alternative_no}  </Title>
//                         </div>
//                       </>
//                     ),
//                     from_which_year: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.from_which_year}  </Title>
//                         </div>
//                       </>
//                     ),
//                     visited_time: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.visited_time}  </Title>
//                         </div>
//                       </>
//                     ),
//                     vehicle_by: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.vehicle_by}  </Title>
//                         </div>
//                       </>
//                     ),
//                     time_visit: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.time_visit}  </Title>
//                         </div>
//                       </>
//                     ),
//                     remark: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.remark}  </Title>
//                         </div>
//                       </>
//                     ),

//                     remark: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.remark}  </Title>
//                         </div>
//                       </>
//                     ),

//                     createdAt: (
//                       <>
//                         <div className="author-info">
//                           <Title level={5}>{user.createdAt ? moment(user.createdAt).format('DD MMMM YYYY') : '-'}</Title>

//                         </div>
//                       </>
//                     ),
//                     action: (
//                       <div className="button-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

// {hasPermission('/purnima-form', 'editPermission') && (
//                         <Button onClick={() => AddUserDetails(user.id)} className="update-btn">
//                           <EditOutlined />
//                         </Button>

// )}

// {hasPermission('/purnima-form', 'deletePermission') && (
//                         <Button onClick={() => showDeleteConfirm(user.id)} className="delete-btn">
//                           <DeleteOutlined />
//                         </Button>
//                          )}
//                       </div>
//                     )
//                   };
//                 })}
//                 pagination={{
//                   ...pagination,
//                   showTotal: total => `Total ${total} records`,
//                   style: { marginRight: 20 }
//                 }}
//                 onChange={handleTableChange}
//                 className="ant-border-space"
//               />
//             </div>
//           </Card>
//         </Col>
//       </Row>

//       <Modal
//         open={isModalVisible}
//         footer={null}
//         onCancel={handleCancel}
//       >
//         <img
//           src={currentImage}
//           alt="Profile"
//           style={{ width: '100%' }}
//         />
//       </Modal>

//       <ImportListModal
//         isVisible={isModalVisibleImportList}
//         onClose={handleCancelImportList}
//         onSuccess={handleOnSuccess}
//       /> 

//       <Drawer
//         title="Purnima Member Details"
//         width={1000}
//         onClose={AddUserDetailsClose}
//         open={AddUserDetailsFormModel}
//         styles={{
//           body: {
//             paddingBottom: 80,
//           },
//         }}
//         maskClosable={false}
//       >
//         <AddUserDetailsModel userId={userId} />
//       </Drawer>
//     </div>
//   );
// }


// export default PurnimaList;


import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input, AutoComplete,
  notification, Modal, Select, Avatar, Typography, TableColumnsType,
  Checkbox, DatePicker, Drawer, Form, InputNumber, Space, Tooltip, Upload, Tag, Spin
} from "antd";

import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined, CalendarOutlined, SendOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined,
  EyeOutlined, UserOutlined, PlusOutlined, UploadOutlined, ReloadOutlined,
  CloseOutlined, PhoneOutlined
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';

import AddUserDetailsModel from './Form';
import AddMessage from "./components/purnimaForm";
import AddImageForm from "./components/purnimaFormWithImg";
import ImportListModal from './components/importListModal';

const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;
const { Item } = Form;
const { TextArea } = Input;

function PurnimaList() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || 20;

  const [purnimaList, setPurnimaList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [purnimaSettingRecord, setPurnimaSettingRecord] = useState();
  
  const [filters, setFilters] = useState({
    name: queryParams.get('name') || '',
    phone_no: queryParams.get('phone_no') || '',
    father_name: queryParams.get('father_name') || '',
    village: queryParams.get('village') || '',
    tehsil: queryParams.get('tehsil') || '',
    district: queryParams.get('district') || '',
    occupation: queryParams.get('occupation') || '',
    occ_district: queryParams.get('occ_district') || '',
    amount_pledge: queryParams.get('amount_pledge') || '',
    alternative_no: queryParams.get('alternative_no') || '',
    dob: queryParams.get('dob') || '',
    from_which_year: queryParams.get('from_which_year') || '',
    visited_time: queryParams.get('visited_time') || '',
    vehicle_by: queryParams.get('vehicle_by') || '',
    time_visit: queryParams.get('time_visit') || '',
    remark: queryParams.get('remark') || '',
    createdAt: queryParams.get('createdAt') || '',
  });

  // Drawer states
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [form] = Form.useForm();
  const [txnDate, setTxnDate] = useState(null);

  // Filter and modal states
  const [showPurnimaFilter, setShowPurnimaFilter] = useState(true);
  const [showPurnimaMessageForm, setShowPurnimaMessageForm] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  // Enhanced table columns with better styling
  const columns = [
    {
      title: <Text strong style={{ color: '#7a0000' }}>#</Text>,
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Phone No</Text>,
      dataIndex: "phone_no",
      key: "phone_no",
      fixed: 'left',
      width: 140,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Name</Text>,
      dataIndex: "name",
      key: "name",
      width: 150,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Amount Pledge</Text>,
      dataIndex: "amount_pledge",
      key: "amount_pledge",
      width: 130,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Father Name</Text>,
      dataIndex: 'father_name',
      key: 'father_name',
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Village</Text>,
      dataIndex: "village",
      key: "village",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Tehsil</Text>,
      dataIndex: "tehsil",
      key: "tehsil",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>District</Text>,
      dataIndex: "district",
      key: "district",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Occupation</Text>,
      dataIndex: "occupation",
      key: "occupation",
      width: 130,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Occ District</Text>,
      dataIndex: "occ_district",
      key: "occ_district",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Inspiration</Text>,
      dataIndex: "inspiration_remark",
      key: "inspiration_remark",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Alt. No</Text>,
      dataIndex: "alternative_no",
      key: "alternative_no",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>DOB</Text>,
      dataIndex: "dob",
      key: "dob",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>From Year</Text>,
      dataIndex: "from_which_year",
      key: "from_which_year",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Visits</Text>,
      dataIndex: "visited_time",
      key: "visited_time",
      width: 100,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Vehicle</Text>,
      dataIndex: "vehicle_by",
      key: "vehicle_by",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Visit Time</Text>,
      dataIndex: "time_visit",
      key: "time_visit",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Remark</Text>,
      dataIndex: "remark",
      key: "remark",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Entry Date</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Actions</Text>,
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 120,
      align: 'center',
    }
  ];

  useEffect(() => {
    const { state } = history.location;
    const restoredPage = state?.page || currentPage;
    const restoredLimit = state?.limit || limit;
    getPurnimaList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
  }, [history.location]);

  // Drawer functions
  const showDrawer = (userId = null) => {
    if (userId) {
      setCurrentUserId(userId);
      setIsUpdateMode(true);
      fetchPurnimaDetails(userId);
    } else {
      setCurrentUserId(null);
      setIsUpdateMode(false);
      form.resetFields();
      setTxnDate(null);
    }
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setCurrentUserId(null);
    setIsUpdateMode(false);
    form.resetFields();
    setTxnDate(null);
  };

  const fetchPurnimaDetails = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/purnima_form/read/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        form.setFieldsValue(response.data.result);
        const dobValue = response.data.result.dob;
        if (dobValue && dobValue !== '0000-00-00' && moment(dobValue).isValid()) {
          setTxnDate(dobValue);
        } else {
          setTxnDate(null);
        }
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch Purnima member details',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      
      // Handle DOB properly - send null instead of empty string
      if (txnDate && txnDate !== '0000-00-00') {
        const formattedDate = moment(txnDate).format('YYYY-MM-DD');
        values.dob = formattedDate;
      } else {
        values.dob = null;
      }

      if (isUpdateMode) {
        const response = await axios.patch(`${baseUrl}/purnima_form/update/${currentUserId}`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
        if (response.status === 200) {
          notification.success({
            message: 'Success',
            description: 'Purnima member updated successfully!',
            placement: 'topRight'
          });
          closeDrawer();
          getPurnimaList(currentPage, limit, sortField, sortOrder, search, filters);
        }
      } else {
        const response = await axios.post(`${baseUrl}/purnima_form/create`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
        if (response.status === 200) {
          notification.success({
            message: 'Success',
            description: 'Purnima member added successfully!',
            placement: 'topRight'
          });
          form.resetFields();
          setTxnDate(null);
          closeDrawer();
          getPurnimaList(currentPage, limit, sortField, sortOrder, search, filters);
        }
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error.response?.data?.message || 'Operation failed',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (date, dateString) => {
    if (date) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      setTxnDate(formattedDate);
    } else {
      setTxnDate(null);
    }
  };

  async function getPurnimaList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setLoading(true);
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/purnima_form/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setPurnimaList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch Purnima data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${baseUrl}/purnima_form/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getPurnimaList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Purnima member deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete Purnima member',
        placement: 'topRight'
      });
    }
  };

  const showDeleteConfirm = (id, userName) => {
    confirm({
      title: 'Delete Purnima Member',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Are you sure you want to delete this Purnima member?</p>
          {userName && (
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              padding: '8px 12px', 
              borderRadius: '6px',
              marginTop: '8px'
            }}>
              <Text strong style={{ color: '#cf1322' }}>Member to be deleted:</Text>
              <br />
              <Text>{userName}</Text>
            </div>
          )}
          <p style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '8px' }}>
            ⚠️ This action cannot be undone.
          </p>
        </div>
      ),
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
        style: { borderRadius: '6px' }
      },
      cancelButtonProps: {
        style: { borderRadius: '6px' }
      },
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    history.push(`?page=${current}&limit=${pageSize}`);
    getPurnimaList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set('limit', value);
    updatedQueryParams.set('page', 1);
    history.push(`?${updatedQueryParams.toString()}`);
    getPurnimaList(1, value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);
  };

  const handleSearch = () => {
    getPurnimaList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      name: '',
      phone_no: '',
      father_name: '',
      village: '',
      tehsil: '',
      district: '',
      occupation: '',
      occ_district: '',
      amount_pledge: '',
      alternative_no: '',
      dob: '',
      from_which_year: '',
      visited_time: '',
      vehicle_by: '',
      time_visit: '',
      remark: '',
      createdAt: '',
    };
    setFilters(resetFilters);
    setSearch('');
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach(key => {
      updatedQueryParams.delete(key);
    });
    history.push(`?${updatedQueryParams.toString()}`);
    getPurnimaList(1, limit, sortField, sortOrder, '', resetFilters);
  };

  const handlePurnimaFormCheckboxChange = async (e) => {
    const isChecked = e.target.checked;
    setShowPurnimaMessageForm(isChecked);
    
    if (isChecked) {
      try {
        setLoading(true);
        await getLatestPurnimaSettingRecord();
      } catch (error) {
        notification.error({
          message: 'Error',
          description: 'Failed to load Purnima settings',
          placement: 'topRight'
        });
      } finally {
        setLoading(false);
      }
    }
  };

  async function getLatestPurnimaSettingRecord() {
    try {
      const response = await axios.get(`${baseUrl}/purnima-message-setting/read`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setPurnimaSettingRecord(response.data.result);
      } else {
        setPurnimaSettingRecord();
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  }

  const exportToExcel = async () => {
    try {
      setLoading(true);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/purnima_form/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const formattedData = response.data.result.map((user, index) => ({
          "Sr.No": index + 1,
          "Phone no": user.phone_no,
          "Name": user.name,
          "Amount Pledge": user.amount_pledge,
          "Father Name": user.father_name,
          "Dob": user.dob ? moment(user.dob).format('DD-MM-YYYY') : '-',
          "Village": user.village,
          "Tehsil": user.tehsil,
          "District": user.district,
          "Occupation": user.occupation,
          "Occupation District": user.occ_district,
          "Inspiration Remark": user.inspiration_remark,
          "Alternative No": user.alternative_no,
          "From Which Year": user.from_which_year,
          "Visited Time's": user.visited_time,
          "Vehicle": user.vehicle_by,
          "Time of visit": user.time_visit,
          "Date": user.createdAt ? moment(user.createdAt).format('DD-MM-YYYY') : '-',
          "Remark": user.remark
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Purnima-members-list");
        XLSX.writeFile(workbook, "Purnima-List.xlsx");
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to export data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <UserOutlined style={{ color: '#fff', fontSize: '20px' }} />
                <Title level={3} style={{ margin: 0, color: '#fff' }}>
                  Purnima Members Management
                </Title>
              </div>
            }
            extra={
              <Space size="middle">
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={() => setIsModalVisibleImportList(true)}
                  style={{ borderRadius: '6px' }}
                >
                  Import List
                </Button>
                {hasPermission('/purnima-form', 'createPermission') && (
                  <Button
                    onClick={() => showDrawer()}
                    style={{
                      background: '#fff',
                      color: '#7a0000',
                      borderColor: '#fff',
                      borderRadius: '6px',
                      fontWeight: 600,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    Add Purnima Member
                  </Button>
                )}
                {hasPermission('/purnima-form', 'downloadPermission') && (
                  <Button
                    type="default"
                    icon={<FileExcelOutlined />}
                    onClick={exportToExcel}
                    style={{ borderRadius: '6px' }}
                  >
                    Export Excel
                  </Button>
                )}
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col>
                        <Checkbox
                          checked={showPurnimaMessageForm}
                          onChange={handlePurnimaFormCheckboxChange}
                          style={{ 
                            transform: 'scale(1.1)',
                            marginRight: '8px'
                          }}
                        >
                          <Text strong style={{ fontSize: '13px' }}>
                            Show Purnima Message Settings
                          </Text>
                        </Checkbox>
                      </Col>
                      
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowPurnimaFilter(!showPurnimaFilter)}
                          style={{
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {showPurnimaFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                    </Row>

                    {/* Purnima Message Forms */}
                    {showPurnimaMessageForm && (
                      <div style={{ 
                        marginTop: '16px',
                        padding: '20px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Title level={4} style={{ marginBottom: '16px', color: '#7a0000', fontWeight: 700 }}>
                          Purnima Message Settings
                        </Title>
                        <Row gutter={[16, 16]}>
                          <Col xs={24}>
                            {purnimaSettingRecord && purnimaSettingRecord?.purnimaMsgRecords?.length > 0 ? (
                              <AddMessage record={purnimaSettingRecord.purnimaMsgRecords[0]} />
                            ) : (
                              <AddMessage record={{}} />
                            )}
                          </Col>
                          <Col xs={24}>
                            {purnimaSettingRecord && purnimaSettingRecord?.purnimaImgRecords?.length > 0 ? (
                              <AddImageForm record={purnimaSettingRecord.purnimaImgRecords[0]} />
                            ) : (
                              <AddImageForm record={{}} />
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}

                    {/* Filters */}
                    {showPurnimaFilter && (
                      <div style={{
                        marginTop: '16px',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Row gutter={[12, 12]}>
                          <Col span={6}>
                            <Input
                              placeholder="Search by phone"
                              value={filters.phone_no}
                              onChange={e => handleFilterChange('phone_no', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Search by name"
                              value={filters.name}
                              onChange={e => handleFilterChange('name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Father name"
                              value={filters.father_name}
                              onChange={e => handleFilterChange('father_name', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Village"
                              value={filters.village}
                              onChange={e => handleFilterChange('village', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Tehsil"
                              value={filters.tehsil}
                              onChange={e => handleFilterChange('tehsil', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="District"
                              value={filters.district}
                              onChange={e => handleFilterChange('district', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Occupation"
                              value={filters.occupation}
                              onChange={e => handleFilterChange('occupation', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Occ District"
                              value={filters.occ_district}
                              onChange={e => handleFilterChange('occ_district', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Amount Pledge"
                              value={filters.amount_pledge}
                              onChange={e => handleFilterChange('amount_pledge', e.target.value)}
                              style={{ borderRadius: '6px' }}
                              type="number"
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Alternative No"
                              value={filters.alternative_no}
                              onChange={e => handleFilterChange('alternative_no', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('dob', dateString)}
                              placeholder="DOB Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="From Which Year"
                              value={filters.from_which_year}
                              onChange={e => handleFilterChange('from_which_year', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Visited Times"
                              value={filters.visited_time}
                              onChange={e => handleFilterChange('visited_time', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Vehicle By"
                              value={filters.vehicle_by}
                              onChange={e => handleFilterChange('vehicle_by', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Time of Visit"
                              value={filters.time_visit}
                              onChange={e => handleFilterChange('time_visit', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="Remark"
                              value={filters.remark}
                              onChange={e => handleFilterChange('remark', e.target.value)}
                              style={{ borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={6}>
                            <DatePicker
                              className="filter_dob"
                              format="DD-MM-YYYY"
                              value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
                              onChange={(date, dateString) => handleFilterChange('createdAt', dateString)}
                              placeholder="Entry Date"
                              style={{ width: '100%', borderRadius: '6px' }}
                            />
                          </Col>
                          <Col span={24}>
                            <Space>
                              <Button
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                style={{ borderRadius: '6px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                              >
                                Search
                              </Button>
                              <Button
                                icon={<ReloadOutlined />}
                                onClick={handleResetFilters}
                                style={{ borderRadius: '6px' }}
                              >
                                Reset All Filters
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                    )}

                    <Row style={{ marginTop: '16px' }}>
                      <Col>
                        <Space align="center">
                          <Text strong>Records per page:</Text>
                          <Select
                            value={limit}
                            onChange={handleLimitChange}
                            style={{ width: 80, borderRadius: '6px' }}
                          >
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                            <Option value={250}>250</Option>
                            <Option value={300}>300</Option>
                          </Select>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={purnimaList.map((user, index) => {
                  const isMatch = user.phone_no === user.user_phone_no;
                  
                  return {
                    key: (limit * (currentPage - 1)) + index + 1,
                    phone_no: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag
                          color={isMatch ? 'success' : 'default'}
                          style={{
                            borderRadius: '12px',
                            padding: '4px 12px',
                            fontWeight: '500'
                          }}
                        >
                          {user.phone_no}
                        </Tag>
                        {isMatch && (
                          <div style={{ fontSize: '10px', color: '#52c41a', marginTop: '2px' }}>
                            ✓ Verified
                          </div>
                        )}
                      </div>
                    ),
                    name: (
                      <Text strong style={{ color: '#262626' }}>{user.name}</Text>
                    ),
                    father_name: (
                      <Text style={{ color: '#595959' }}>{user.father_name || '-'}</Text>
                    ),
                    amount_pledge: (
                      <Text strong style={{ color: '#7a0000' }}>
                        ₹{user.amount_pledge ? Number(user.amount_pledge).toLocaleString() : '0'}
                      </Text>
                    ),
                    dob: (
                      <Text>{user.dob ? moment(user.dob).format('DD MMM YYYY') : '-'}</Text>
                    ),
                    village: (
                      <Text style={{ color: '#595959' }}>{user.village || '-'}</Text>
                    ),
                    tehsil: (
                      <Text style={{ color: '#595959' }}>{user.tehsil || '-'}</Text>
                    ),
                    district: (
                      <Text style={{ color: '#595959' }}>{user.district || '-'}</Text>
                    ),
                    occupation: (
                      <Text style={{ color: '#595959' }}>{user.occupation || '-'}</Text>
                    ),
                    occ_district: (
                      <Text style={{ color: '#595959' }}>{user.occ_district || '-'}</Text>
                    ),
                    inspiration_remark: (
                      <Text style={{ color: '#595959' }}>{user.inspiration_remark || '-'}</Text>
                    ),
                    alternative_no: (
                      <Text style={{ color: '#595959' }}>{user.alternative_no || '-'}</Text>
                    ),
                    from_which_year: (
                      <Text style={{ color: '#595959' }}>{user.from_which_year || '-'}</Text>
                    ),
                    visited_time: (
                      <Tag color="blue" style={{ borderRadius: '12px' }}>
                        {user.visited_time || '0'} times
                      </Tag>
                    ),
                    vehicle_by: (
                      <Text style={{ color: '#595959' }}>{user.vehicle_by || '-'}</Text>
                    ),
                    time_visit: (
                      <Text style={{ color: '#595959' }}>{user.time_visit || '-'}</Text>
                    ),
                    remark: (
                      <Text style={{ color: '#595959' }}>{user.remark || '-'}</Text>
                    ),
                    createdAt: (
                      <Text>
                        {user.createdAt ? moment(user.createdAt).format('DD MMM YYYY') : '-'}
                      </Text>
                    ),
                    action: (
                      <Space size={4}>
                        {hasPermission('/purnima-form', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => showDrawer(user.id)}
                            style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                          >Edit</Button>
                        )}
                        {hasPermission('/purnima-form', 'deletePermission') && (
                          <Button
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => showDeleteConfirm(user.id, user.name)}
                          >Delete</Button>
                        )}
                      </Space>
                    )
                  };
                })}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                  showSizeChanger: false,
                  style: { marginTop: '16px' }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Enhanced Drawer for Add/Edit */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isUpdateMode ? <EditOutlined style={{ color: 'white', fontSize: '18px' }} /> : <UserOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                {isUpdateMode ? 'Update Purnima Member' : 'Add Purnima Member'}
              </Title>
             
            </div>
          </div>
        }
        width={window.innerWidth > 1200 ? 1000 : window.innerWidth > 768 ? 800 : '95%'}
        open={drawerVisible}
        onClose={closeDrawer}
        closable={false}
        bodyStyle={{
          padding: 0,
          background: '#f8f9fa'
        }}
        headerStyle={{
          background: '#7a0000',
          border: 'none'
        }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={closeDrawer}
            style={{ color: 'white' }}
          />
        }
        destroyOnClose
      >
        <div style={{ height: '100%', padding: '24px' }}>
          <Spin spinning={loading}>
            <Card
              bordered={false}
              style={{
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            >
              <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                requiredMark={false}
                style={{ maxWidth: '100%' }}
              >
                <Row gutter={[20, 16]}>
                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Phone Number</Text>}
                      name="phone_no"
                      rules={[
                        { required: true, message: 'Please enter phone number' },
                        { pattern: /^\d{10,12}$/, message: 'Phone must be 10-12 digits!' }
                      ]}
                    >
                      <Input
                        prefix={<PhoneOutlined style={{ color: '#7a0000' }} />}
                        placeholder="Enter phone number"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>
                  
                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Full Name</Text>}
                      name="name"
                      rules={[{ required: true, message: 'Please enter name' }]}
                    >
                      <Input
                        prefix={<UserOutlined style={{ color: '#7a0000' }} />}
                        placeholder="Enter full name"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Father's Name</Text>}
                      name="father_name"
                    >
                      <Input
                        placeholder="Enter father's name"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Village</Text>}
                      name="village"
                    >
                      <Input
                        placeholder="Enter village"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Tehsil</Text>}
                      name="tehsil"
                    >
                      <Input
                        placeholder="Enter tehsil"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>District</Text>}
                      name="district"
                    >
                      <Input
                        placeholder="Enter district"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Occupation</Text>}
                      name="occupation"
                    >
                      <Input
                        placeholder="Enter occupation"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Occupation District</Text>}
                      name="occ_district"
                    >
                      <Input
                        placeholder="Enter occupation district"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Inspiration Remark</Text>}
                      name="inspiration_remark"
                    >
                      <Input
                        placeholder="Enter inspiration remark"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Amount Pledge</Text>}
                      name="amount_pledge"
                    >
                      <InputNumber
                        placeholder="Enter amount"
                        style={{ width: '100%', borderRadius: '8px', height: '40px' }}
                        formatter={value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/₹\s?|(,*)/g, '')}
                        min={0}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Date of Birth</Text>}
                    >
                      <DatePicker
                        onChange={handleDateChange}
                        value={txnDate && txnDate !== "0000-00-00" && moment(txnDate).isValid() ? moment(txnDate) : null}
                        format="DD-MM-YYYY"
                        placeholder="Select date of birth"
                        style={{ width: '100%', borderRadius: '8px', height: '40px' }}
                        suffixIcon={<CalendarOutlined style={{ color: '#7a0000' }} />}
                        allowClear
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Alternative Number</Text>}
                      name="alternative_no"
                    >
                      <Input
                        placeholder="Enter alternative number"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>From Which Year</Text>}
                      name="from_which_year"
                    >
                      <Input
                        placeholder="Enter from which year"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Visited Times</Text>}
                      name="visited_time"
                    >
                      <Input
                        placeholder="Enter visited times"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Vehicle</Text>}
                      name="vehicle_by"
                    >
                      <Input
                        placeholder="Enter vehicle type"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12} lg={8}>
                    <Item
                      label={<Text strong>Time of Visit</Text>}
                      name="time_visit"
                    >
                      <Input
                        placeholder="Enter time of visit"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24}>
                    <Item
                      label={<Text strong>Remark</Text>}
                      name="remark"
                    >
                      <TextArea
                        placeholder="Enter any remarks or notes"
                        rows={3}
                        style={{ borderRadius: '8px' }}
                      />
                    </Item>
                  </Col>
                </Row>

                <div style={{
                  marginTop: '32px',
                  paddingTop: '24px',
                  borderTop: '1px solid #f0f0f0',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '12px'
                }}>
                  <Button
                    onClick={closeDrawer}
                    size="large"
                    style={{ borderRadius: '8px', minWidth: '100px' }}
                  >
                    Cancel
                  </Button>
                  
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{
                      borderRadius: '8px',
                      minWidth: '100px',
                      background: '#7a0000'
                    }}
                    loading={loading}
                  >
                    {isUpdateMode ? 'Update Member' : 'Save Member'}
                  </Button>
                </div>
              </Form>
            </Card>
          </Spin>
        </div>
      </Drawer>

      {/* Import Modal */}
      <ImportListModal
        isVisible={isModalVisibleImportList}
        onClose={() => setIsModalVisibleImportList(false)}
        onSuccess={() => {
          setIsModalVisibleImportList(false);
          getPurnimaList();
        }}
      />

      {/* Image Modal */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        centered
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%', borderRadius: '8px' }}
        />
      </Modal>
    </div>
  );
}

export default PurnimaList;
